import { Page, PageSetting } from '@alucio/aws-beacon-amplify/src/models'

export const isSourceHiddenPage = (page?: Pick<Page, 'isHidden' | 'sourceIsHidden'>): boolean =>
  !!(page?.sourceIsHidden || page?.isHidden)

export const getVisibleSourcePages = (pages: Page[]): Page[] =>
  pages.filter(page => !isSourceHiddenPage(page))

export const getVisibleSourcePageIds = (pages: Page[]): Set<string> =>
  new Set(getVisibleSourcePages(pages).map(page => page.pageId))

export const filterSourceHiddenPageIds = (pageIds: string[] | undefined, pages: Page[]): string[] => {
  if (!pageIds?.length) {
    return [];
  }

  const visiblePageIds = getVisibleSourcePageIds(pages);
  return pageIds.filter(pageId => visiblePageIds.has(pageId));
}

export const isAllSlidesChecked = (
  pages: Page[],
  selectedSlides: Record<string, boolean>,
) => {
  return (
    pages.length === Object.values(selectedSlides).length &&
    Object.values(selectedSlides).every(selected => selected)
  )
}
export const addSlidesToGroup = (pageIds: string[] | undefined, selectedPages, group) => {
  const pagesToAdd = pageIds ?? Object
    .entries(selectedPages)
    .filter(([_, v]) => v)
    .map(([k]) => k)
    .sort((a, b) => a.localeCompare(b, 'en', { numeric: true }))
  group.pageIds = [...group.pageIds ?? [], ...pagesToAdd];

  // ANALYTIC TRACKING: adding slide to a group
  pagesToAdd.forEach(slideId => {
    analytics?.track('ADD_SLIDE', { groupId: group.id, pageId: slideId });
  });
}

export const buildPageSettingsFromPages = (pages: Page[]): PageSetting[] => pages.reduce<PageSetting[]>(
  (acc: PageSetting[], currVal: Page) => {
    const hasLinkedSlides = !!currVal.linkedSlides?.length;
    const hasHiddenMetadata = isSourceHiddenPage(currVal);

    if ((!hasHiddenMetadata && currVal.isRequired) || hasLinkedSlides || hasHiddenMetadata) {
      acc.push({
        pageId: currVal.pageId,
        number: currVal.number,
        isRequired: hasHiddenMetadata ? false : currVal.isRequired ?? false,
        isHidden: currVal.isHidden ?? false,
        sourceIsHidden: currVal.sourceIsHidden ?? false,
        linkedSlides: currVal.linkedSlides ?? [],
      })
    }
    return acc;
  },
  [],
)
